import produce from 'immer';

const INITIAL_STATE = {
  username: null,
  accessLevel: null,
  signed: false,
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  return produce(state, draft => {
    switch (action.type) {
      case '@auth/SIGN_IN_REQUEST':
        draft.loading = true;
        break;

      case '@auth/SIGN_IN_SUCCESS':
        draft.username = action.payload.username;
        draft.accessLevel = action.payload.accessLevel;
        draft.signed = true;
        draft.loading = false;
        break;

      case '@auth/SIGN_FAILURE':
        draft.loading = false;
        break;

      case '@auth/FORGOT_PASSWORD_REQUEST':
        draft.loading = true;
        break;

      case '@auth/FORGOT_PASSWORD_SUCCESS':
        draft.loading = false;
        break;

      case '@auth/PASSWORD_CHALLENGE_REQUEST':
        draft.loading = false;
        break;

      case '@auth/SIGN_OUT':
        draft.session = null;
        draft.user = null;
        draft.signed = false;
        break;

      default:
    }
  });
};
